<template>
  <a-drawer placement="left" :closable="false" :visible="visible" :mask="false" :get-container="false"
    :wrap-style="{ position: 'absolute' }"
    style="background: rgba(0, 32, 54, 0.75); box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1)" :zIndex="980">
    <div slot="title" style="margin-bottom: 0">
      <div class="radius"></div>
      <div class="radius-title">查询</div>
    </div>
    <a-form class="log-form" layout="vertical" ref="addOrUpdateForm" :model="addOrUpdateForm" :rules="rules">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="图层">
        <a-select default-value="请选择物探点数据或管线数据" v-model="currentSelectLayer" style="color: #fff"
          @change="layerSelectChange">
          <a-select-option value="gis_pipe_network"> 物探点图层</a-select-option>
          <a-select-option value="search_gis_pipe_line"> 管线图层</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="查询属性">
        <!--      管线图层  -->
        <a-select v-if="currentSelectLayer === 'search_gis_pipe_line'" default-value="请选择"
          v-model="currentSelectLayerQueryType" @change="layerPropertiesQuery" style="color: #fff">
          <a-select-option value="pipe_diameter"> 管径</a-select-option>
          <a-select-option value="pipe_material"> 管材</a-select-option>
          <a-select-option value="class_no"> 分类编码</a-select-option>
          <a-select-option value="user_point_number"> 用户编码 </a-select-option>
          <a-select-option value="user_point_name"> 用户名称 </a-select-option>
        </a-select>
        <!--     物探点图层   -->
        <a-select v-if="currentSelectLayer === 'gis_pipe_network'" default-value="请选择"
          v-model="currentSelectLayerQueryType" @change="layerPropertiesQuery" style="color: #fff">
          <a-select-option value="texture_material">材质</a-select-option>
          <a-select-option value="caliber">口径</a-select-option>
          <a-select-option value="class_no">分类编码</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item style="margin-bottom: 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="属性值">
        <a-select v-if="currentSelectLayerQueryType !== 'class_no' &&
          currentSelectLayerQueryType !== 'user_point_number' &&
          currentSelectLayerQueryType !== 'user_point_name'
        " mode="multiple" v-model="layerPropertiesValues">
          <a-select-option v-for="(item, index) in propertiesTypeOptions" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
        <a-input v-else v-model.trim="layerPropertiesValue"
          onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          onafterpaste="this.value=this.value.replace(/\s/g,'')" />
      </a-form-item>
    </a-form>
    <div style="margin-top: 30px">
      <a-button style="margin-left: 30px" type="primary" @click="queryLayerProperties">搜索</a-button>
      <a-button style="margin-left: 8px" @click="reset">重置</a-button>
      <h3 style="color: #ffffff; margin-top: 30px;">管网长度：{{ this.messages }} m(米)</h3>

    </div>
  </a-drawer>
</template>

<script>
import {
  getGisCqlExtent,
  getGisNetWorkCqlExtent,
  listByGroupProperties,
  listPipeNetworkByGroupProperties
} from '@/api/manage'
import Feature from 'ol/Feature'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import LineString from 'ol/geom/LineString'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
// import { geoserverWFS } from '@/api/manage'
export default {
  name: 'BigMapDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      messages: '',
      selectedItems: [],
      propertiesTypeOptions: [],
      currentSelectLayer: 'search_gis_pipe_line', // 当前选择的图层
      currentSelectLayerQueryType: '', // 当前选择查询的类型
      layerPropertiesValues: [], // 图层属性查询条件
      layerPropertiesValue: '', // 图层属性查询条件
      addOrUpdateForm: {},
      redSource: null,
      query: {
        road: '',
        classNo: '',
        geophysicalPointNumber: '',
        connection: '',
        zoneId: '',
        tenantId: this.$store.state.user.info.tenantId,
        pipeMaterial: '',
        pipeDiameter: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 24 }
      }
    }
  },
  computed: {
    rules () {
      return {}
    }
  },
  methods: {
    reset () {
      this.messages = ''
      this.currentSelectLayerQueryType = ''
      this.layerPropertiesValue = ''
      this.layerPropertiesValues = []
      if (this.redSource != null) {
        this.redSource.clear()
      }
      this.$parent.removeLayerByName('condition_query_wms_layer')
      this.$parent.removeLayerByName('condition_query_wms_layer_point')
    },
    layerSelectChange (val) {
      this.currentSelectLayer = val
    },
    handleChange (selectedItems) {
      this.selectedItems = selectedItems
    },
    // GIS图查询属性请求接口显示管网长度
    queryLengthStatistics (classNo) {
      this.messages = 0
      const that = this
      this.query = {
        road: '',
        classNo: '',
        geophysicalPointNumber: '',
        connection: '',
        zoneId: '',
        tenantId: this.$store.state.user.info.tenantId,
        pipeMaterial: '',
        pipeDiameter: ''
      }
      if (this.currentSelectLayerQueryType === 'pipe_diameter') {
        for (let index = 0; index < this.layerPropertiesValues.length; index++) {
          const pipeDiameter = this.layerPropertiesValues[index]
          this.query.pipeDiameter = pipeDiameter
          const params = {
            ...that.query
          }
          this.$http.get('/pipe-network/gis/pipe-lines/getLength', { params }).then((data) => {
            console.log('``````````', data.data)

            that.messages += Number(data.data)
          })
        }
      } else if (this.currentSelectLayerQueryType === 'pipe_material') {
        for (let index = 0; index < this.layerPropertiesValues.length; index++) {
          const pipeMaterial = this.layerPropertiesValues[index]
          this.query.pipeMaterial = pipeMaterial
          const params = {
            ...that.query
          }
          this.$http.get('/pipe-network/gis/pipe-lines/getLength', { params }).then((data) => {
            console.log('+++++++++++', data.data)
            that.messages += Number(data.data)
          })
        }
      } else {
        this.query.classNo = classNo != undefined ? classNo : this.layerPropertiesValue
        const params = {
          ...that.query
        }
        this.$http.get('/pipe-network/gis/pipe-lines/getLength', { params }).then((data) => {
          console.log('----------', data.data)
          that.messages += Number(data.data)
        })
      }
    },
    async queryLayerProperties () {
      try {

        this.$parent.redSource.clear();
        if (this.redSource !== null) {
          this.redSource.clear();
        }

        if (!this.currentSelectLayerQueryType ||
          (this.layerPropertiesValues.length === 0 && !this.layerPropertiesValue)) {
          this.$message.error('请选择查询属性或者输入、选择属性值！');
          return;
        }

        this.$message.info('搜索中');
        let cql = `is_deleted = false and tenant_id = '${this.$store.state.user.info.tenantId}' and`;

        // 处理属性查询条件
        if (this.currentSelectLayerQueryType !== 'class_no' &&
          this.currentSelectLayerQueryType !== 'user_point_number' &&
          this.currentSelectLayerQueryType !== 'user_point_name') {
          this.queryLengthStatistics();
          const tmpCql = this.layerPropertiesValues
            .map((item, index) =>
              `${index === 0 ? '' : ' or '}${this.currentSelectLayerQueryType}='${item}'`
            )
            .join('');
          cql += `(${tmpCql})`;
        } else {
          let class_no = this.layerPropertiesValue;

          // 异步请求 class_no
          if (this.currentSelectLayerQueryType !== 'class_no') {

            const params = {
              orderType: 'asc',
              sysType: true,
              page: 1,
              limit: 10
            };
            if (this.currentSelectLayerQueryType === 'user_point_number') {
              params.userNo = this.layerPropertiesValue
            } else if (this.currentSelectLayerQueryType === 'user_point_name') {
              params.userNikeName = this.layerPropertiesValue
            }

            const res = await this.$http.get('/pipe-network/gis_class_user_water_meters/page', { params });
            class_no = res.data.list[0].classNo;
          }
          this.queryLengthStatistics(class_no);
          // 构建 CQL
          if (this.currentSelectLayer === 'gis_pipe_network') {
            cql += ` ${this.currentSelectLayerQueryType}='${class_no}'`;
          } else {
            cql += ` (start_class_no='${class_no}' or end_class_no='${class_no}')`;
          }
        }

        // 执行查询
        this.$parent.queryWmsLayers('smart_water', `smart_water:${this.currentSelectLayer}`, cql);

        // 定位到结果
        if (this.currentSelectLayer === 'search_gis_pipe_line') {
          const res = await getGisCqlExtent(cql);
          const xy = JSON.parse(res.data[0].geoJson).coordinates;
          this.$parent.getBigMap().getView().setCenter(xy[0]);
          this.$parent.getBigMap().getView().setZoom(18);
        } else {
          const res = await getGisNetWorkCqlExtent(cql);
          const xy = JSON.parse(res.data.geoJson).coordinates;
          if (xy.length > 0) {
            this.$parent.getBigMap().getView().setCenter(xy);
            this.$parent.getBigMap().getView().setZoom(18);
          }
        }
      } catch (error) {
        console.error('查询失败:', error);
        // this.$message.error('查询失败，请稍后重试');
      }
    },
    layerPropertiesQuery (propertiesType) {
      this.currentSelectLayerQueryType = propertiesType
      this.layerPropertiesValues = []
      this.layerPropertiesValue = ''
      this.propertiesTypeOptions = []
      if (propertiesType === 'pipe_diameter' || propertiesType === 'pipe_material') {
        listByGroupProperties(propertiesType).then((res) => {
          res.data.forEach((items, index) => {
            this.propertiesTypeOptions.push(items)
          })
        })
      }
      if (propertiesType === 'texture_material' || propertiesType === 'caliber') {
        listPipeNetworkByGroupProperties(propertiesType).then((res) => {
          res.data.forEach((items, index) => {
            this.propertiesTypeOptions.push(items)
          })
        })
      }
    },
    show (arr) {
      this.$nextTick(() => { })
    },
    close () {
      //   this.disableSubmit = false
      this.selectedRowKeys = []
    },

    handleOk () {
      const that = this
      this.redSource.clear()
      console.log(that.selectedRows)
      const arr = this.selectedRows
      this.$emit('close', arr)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-drawer-content-wrapper {
  background: rgb(0, 32, 54);
  opacity: 0.75;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-wrapper-body {
  background: rgba(0, 32, 54, 0.75);
  /*opacity: 0.75;*/
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-header {
  background: rgba(8, 144, 242, 0.18);
  border-bottom: 0px solid #e8e8e8;
}

/deep/ .ant-form-item-label>label {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.56px;
  font-weight: 400;
}

/deep/ .ant-select-selection {
  border: 1px solid #939393;
  border-radius: 4px;
  background: rgba(0, 32, 54, 0);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

.radius {
  float: left;
  width: 4px;
  height: 16px;
  background: #ffffff;
  border-radius: 0px;
}

.radius-title {
  margin-left: 15px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
}

.log-form {
  padding: 0;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #404549;
  letter-spacing: 0.56px;
  font-weight: 400;
}

.ant-drawer-body {
  padding: 0;
}
</style>
